/**
 * Icons sizes im tailwind
 */
export const sizes = {
    small: 'h-4',
    medium: 'h-6',
    large: 'h-8',
}

/**
 * Artnet logo colors and sizes in tailwind
 */
export const logoSizeAndColor: {
    fills: { [color: string]: string }
    sizes: { [size: string]: string }
} = {
    fills: {
        orange: 'fill-brand-orange',
        black: 'fill-brand-black',
        white: 'fill-brand-white',
    },
    sizes: {
        small: 'h-5', //  1.25rem/* 20px
        medium: 'h-6', //  1.5rem/* 24px
        large: '',
        // large: 'h-12',
    },
}

/**
 * Social media icon colors in tailwind
 */
export const socialIconColors = {
    white: ['stroke-brand-white', 'fill-brand-white'],
    black: ['stroke-brand-black', 'fill-brand-black'],
}
